import { TFunction } from "core/i18n";
import { LocalizedValue, NormalizedLocalizedData } from "types";

export const getLocalizedEnumMap = (t: TFunction, enumObject: NormalizedLocalizedData<LocalizedValue>): { [id: string]: string } =>
    Object.values(enumObject)
        .map((item) => [item.id, t(item.msg)])
        .reduce((acc, [key, value]) => Object.assign(acc, { [key]: value }), {});
